module.exports = __webpack_public_path__ + "7d088296/img/comment-question-icon.7dd26e04.svg";